import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import '../../../static/css/main.css'
import '../../../static/fonts/stylesheet.css'

import icon_s3_1 from '../../../static/img/icon-s3-1.svg'
import arrow from '../../../static/img/Arrow_dropdown-gray.svg'
import heart from "../../../static/img/heart.svg"
import icon_heart from "../../../static/img/icon-heart-gray.svg"
import icon_home from "../../../static/img/icon-home-gray.svg"
import { digitNumber } from '../../funcs/funcs';
import { selectLifeOption, selectMortgageBalance, selectPropertyOption } from '../../precalc/precalcSlice';
import { selectIdBank, selectIdPoliceL, selectIdPoliceP, selectIsLoadPari, selectPhone, selectSumFinalL, selectSumFinalP, setLinkPayPari } from '../calcSlice';
import { selectNumberContract, selectStringDateBegin, selectStringDateContract } from '../contractSlice';
import { selectBirthDateString, selectIssuedBy, selectLastname, selectName, selectPatronymic, selectRegAdr, selectSerial, selectSex, selectSubdivision } from '../personSlice';
import { list_banks } from '../../../static/vars';
import { selectAddresObject, selectNumLevels, selectYearBuild } from '../objectSlice';
import { setShowPopUpManager } from '../../home/homeSlice';
import { sendToManager } from '../../home/homeApi';

export function PoliceCardOneB(props) {
    const dispath = useDispatch()

    const [showDataPolice, setShowDataPolice] = useState(false);
    const [isBuy, setIsBuy] = useState(false);
    const [sendToManagerDone, setSendToManagerDone] = useState(false);

    const numberContract = useSelector(selectNumberContract)
    const stringDateBegin = useSelector(selectStringDateBegin)
    const stringDateContract = useSelector(selectStringDateContract)

    const idBank = useSelector(selectIdBank)
    const mortgageBalance = useSelector(selectMortgageBalance)

    const name = useSelector(selectName)
    const lastname = useSelector(selectLastname)
    const patronymic = useSelector(selectPatronymic)
    const birthDateString = useSelector(selectBirthDateString)

    const sex = useSelector(selectSex)
    const regAdr = useSelector(selectRegAdr)

    const serial = useSelector(selectSerial)

    const subdivision = useSelector(selectSubdivision)
    const issuedBy = useSelector(selectIssuedBy)

    const addresObject = useSelector(selectAddresObject)

    const phone = useSelector(selectPhone)
    const yearBuild = useSelector(selectYearBuild)
    const numLevels = useSelector(selectNumLevels)

    const handleShowDataPolice = () => {
        setShowDataPolice(!showDataPolice)
    }

    const handlePay = () => {
        window.ym(90426649,'reachGoal','kypit_clck')
        // if (props.insurance !== 'ПАРИ') {
        //     dispath(setLinkPayPari(`/pay/${idPoliceP || '0'}/${idPoliceL || '0'}/${ sumFinalP || '0'}/${ sumFinalL || '0'}`))
        // }
        // props.setShowPayPariWindow(true)
        props.handlePay()
        setIsBuy(true)
        props.setWaitPay(true)
    }

    const handleManager = () => {
        sendToManager({
            name: name,
            phone: phone,
            addres: regAdr,
            date_start: stringDateBegin,
            messenger: '',
            comment: 'Хотел купить онлайн, ' + props.insurance + ', ' + list_banks.find(x => x.value === idBank).label,
            checkedSelf: true,
        }, () => {
            setSendToManagerDone(true)
            console.log('send to manager good')
        })
    }

    return (


        <div class="tab-body-blok-info-401 policy_card" id="tab-body-blok-info-401-6">
            <div class="tab-body-blok-info-401-element" style={{alignItems: 'center'}}>
                <img src={props.icon} alt="" />
                <p class="blok-info-401-element-text">{props.insurance}</p>
            </div>
            {!props.selfManager &&
                <div class="tab-body-4-blok-price">
                    <div class="tab-body-4-price-1">
                        {digitNumber(Math.round(100 * ((props.sum) / (100 - 10))).toString())}
                    </div>
                    <div class="tab-body-4-price-2">
                        -20%
                    </div>
                    <div class="tab-body-4-price-3">
                        {digitNumber(Math.round(((props.sum))).toString()) + ' ₽'}
                    </div>
                </div>
            }
            {
                props.selfManager &&
                <div style={{ textAlign: 'left', fontSize: '12px', marginBottom: '7px' }}>
                    Страховая не сформировала полис, вы можете оформить с менеджером
                </div>
            }
            <div onClick={handleShowDataPolice} class="tab-body-4-dopinfo-blok-link">
                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-6">Данные
                    полиса
                    <img class="icon-down-arrow icon-down-arrow-401"
                        src={arrow} alt="arrow icon" />
                </p>
            </div>

            {/* DATA POLICE */}
            {showDataPolice &&
                <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-6" style={{ display: 'block' }}
                    id="tab-body-4-blok-dopinfo-6">
                    <div style={{textAlign: 'left'}}>
                        <img class="icon-home-gray" src={props.type === 'Жизнь' ? icon_heart : icon_s3_1} alt="home" />
                    </div>
                    <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-3">
                        Будет застраховано: {props.type}<br />
                        Банк: {list_banks.find(x => x.value === idBank).label}<br />
                        Страховая компания: {props.insurance}<br />
                        Остаток кредита: {mortgageBalance}<br />
                        Кредитный договор: {numberContract}<br />
                        Дата заключения: {stringDateContract}<br />
                        {/* Дата окончания: 02.02.2031<br /> */}
                        Дата начала действия полиса: {stringDateBegin}<br />
                        {/* Дата окончания действия полиса: 02.02.2031<br /> */}
                        Фамилия: {lastname}<br />
                        Имя: {name}<br />
                        Отчетство: {patronymic}<br />
                        Дата рождения: {birthDateString}<br />
                        Документ: Паспорт<br />
                        Серия/номер: {serial.split(' ')[0] + ' '}{serial.split(' ')[1]}<br />
                        Код подразделения: {subdivision}<br />
                        Кем выдан: {issuedBy}<br />
                        Адрес регистрации: {regAdr}<br />
                        Пол: {sex}<br />
                        Адрес страхуемого объекта: {addresObject}<br />
                        Год постройки: {yearBuild}<br />
                        {/* Этажность: {numLevels} */}
                        </p>
                </div>
            }

            {!isBuy && !props.selfManager && !props.is_buy &&
                <div class="button button-1 button-novostroiki-1 button-step-4002"
                    onClick={handlePay}
                >Перейти к оплате</div>
            }
            {!isBuy && props.selfManager &&
                <div class="button button-1 button-novostroiki-1 button-step-4002"
                    onClick={handleManager}
                >{sendToManagerDone ? 'Отправлено' : 'Оформить с менеджером'}</div>
            }
            {(isBuy || props.is_buy) && !props.waitPay &&
                <div class="button button-1 button-novostroiki-1 button-step-4002 button-step-4002-active"
                    onClick={props.handleDownload}
                >
                    Скачать
                </div>
            }

            {isBuy && props.waitPay &&
                <div class="button button-1 button-novostroiki-1 button-step-4002 button-step-4002-active"
                    href="calculator-finish.html">Ожидание</div>
            }

            {isBuy &&
                <div onClick={() => setIsBuy(false)}>
                    <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-6">
                        Оплатить снова
                    </p>
                </div>
            }
        </div>
    );
}



